import * as actionType from "../actions/actionType";

const initialState = {
  productName: "",
  productId: "",
  chooseType: "productName",
  productCategory: "",
  productType: "",
  openList: [],
  openPage: 1,
  openPageSize: 20,
  openTableListTotal: 0,

  invitationName: "",
  targetList: [],
  targetPage: 1,
  targetPageSize: 20,
  targetTableListTotal: 0,

  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.SAMPLELIST_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    default:
      return state;
  }
};
